import { RecommendedActionStatusEnum } from '@/types/schema';

import { AiRecommendationFragment } from './graphql/fragments/generated/AiRecommendation';

export enum InsightsRecommendationSentimentTypeEnum {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  NEUTRAL = 'neutral',
}

export enum InsightsActionModalTypeEnum {
  CHECKIN_OKR = 'CHECKIN_OKR',
  GIVE_FEEDBACK = 'GIVE_FEEDBACK',
  GIVE_PRAISE = 'GIVE_PRAISE',
  SCHEDULE_MEETING = 'SCHEDULE_MEETING',
  SETUP_ONE_ON_ONE = 'SETUP_ONE_ON_ONE',
  CREATE_HABIT = 'CREATE_HABIT',
}
export interface UpdateRecommendationStatusProps {
  recommendationId: string;
  status: RecommendedActionStatusEnum;
  snoozeUntil?: string;
}

export type InsightsRecommendationItem = AiRecommendationFragment;
